import { render } from "./UsagePaging.vue?vue&type=template&id=15c4d793&scoped=true"
import script from "./UsagePaging.vue?vue&type=script&lang=ts"
export * from "./UsagePaging.vue?vue&type=script&lang=ts"

import "./UsagePaging.vue?vue&type=style&index=0&id=15c4d793&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15c4d793"

export default script